// extracted by mini-css-extract-plugin
export default {"main":"AssetView_main__tGlL4","idea":"AssetView_idea__yNfWC","ybl":"AssetView_ybl__cEPgM","fintech":"AssetView_fintech__NMqyB"};